import Modal from 'react-bootstrap/Modal';
import { ModalBody, ModalHeader } from 'react-bootstrap';
import { financeAssets } from '../../../services/constant';
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
const DetailModal = ({ details, setDetails, setConfirm, setRefund, showAll, setShowAll, expend, setExpend }) => {
  const [total, setTotal] = useState(45);
  const [expend1, setExpend1] = useState(false);
  const [upload, setUpload] = useState(false);
  const handleClose = () => { setDetails(false); setRefund(false); setShowAll(false); setExpend(false); setExpend1(false); }

  const show = () => {
    setShowAll(true);
    setExpend(true);
    setExpend1(true);
    setTotal(75);
  }
  useEffect(() => {
    show();
    }, []);

  const onConfirm = () => {
    setDetails(false);
    setConfirm(true);
  }
  return (
    <Modal
      show={details}
      onHide={handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ maxWidth: '100%', borderRadius: '1.2rem !important', border: '1px solid #fff', overflow: 'hidden' }}
    >
      <ModalHeader closeButton className='h-[64px] bg-[#F2F5F8]'> <h3 className='font-24-600 font-color ml-auto '>Pedir Reembolso</h3></ModalHeader>
      <ModalBody >
        <div className='p-[17px] h-[40vh] '>
          <div className='rounded-[7px] border-[1px] flex flex-col p-[8px] gap-[16px]'>
            <div className='flex flex-row justify-between'>
              <div className='font-16-600 text-[#697DA4]'>
                {showAll ? (<label key={1} className="custom-select-option p-0">
                  <input
                    type="checkbox"
                    checked={expend1}
                    onChange={() => { setExpend1(!expend1); if (!expend1) setTotal(75); else setTotal(30); }}
                    className="custom-checkbox-input"
                  />
                  <span className="custom-checkbox"></span>
                  Visita de &nbsp; <span className='font-14-400'>10/09/204 às 12:00</span>
                </label>) : (<p> Visita de &nbsp; <span className='font-14-400'>10/09/204 às 12:00</span> </p>)}

              </div>
              <p className='text-[#697DA4] font-16-600'>NIF: 2221459</p>
            </div>
            {
              expend1 ? (
                <>
                  <div className='flex flex-row justify-between mt-[16px]'>
                    <p className='font-14-500 font-color'> 1 Consulta </p>
                    <p className='font-16-600 font-color'> 35€</p>
                  </div>

                  <div className='flex flex-row justify-between'>
                    <p className='font-14-500 font-color'> 2 Antissépticos e Desinfetantes </p>
                    <p className='font-16-600 font-color'> 10€</p>
                  </div>
                </>
              ) : (<></>)
            }
          </div>
          {
            showAll && expend ? (
              <div className='rounded-[7px] border-[1px] flex flex-col p-[8px] gap-[16px] mt-[16px]'>
                <div className='flex flex-row justify-between'>
                  <div className='font-16-600 text-[#697DA4]'>
                    <label key={2} className="custom-select-option p-0">
                      <input
                        type="checkbox"
                        checked={expend}
                        onChange={() => { setExpend(!expend); if (!expend) setTotal(75); else setTotal(45); }}
                        className="custom-checkbox-input"
                      />
                      <span className="custom-checkbox"></span>
                      <span> Visita de <span className='font-14-400'>10/09/204 às 14:30</span> </span>
                    </label>
                  </div>
                  <p className='text-[#697DA4] font-16-600'>Nº Apólice: 1200405</p>
                </div>

                <div className='flex flex-row justify-between mt-[16px]'>
                  <p className='font-14-500 font-color'> Raios-X e ultrassonografia </p>
                  <p className='font-16-600 font-color'> 30€</p>
                </div>
              </div>
            ) : (<></>)
          }
          {
            showAll && !expend ? (
              <div className='rounded-[7px] border-[1px] flex flex-col p-[8px] gap-[16px] mt-[16px]'>
                <div className='flex flex-row justify-between'>
                  <div className='font-16-600 text-[#697DA4]'>
                    <label key={2} className="custom-select-option p-0">
                      <input
                        type="checkbox"
                        checked={expend}
                        onChange={() => { setExpend(!expend); if (!expend) setTotal(75); else setTotal(45); }}
                        className="custom-checkbox-input"
                      />
                      <span className="custom-checkbox"></span>
                      <span> Visita de <span className='font-14-400'>10/09/204 às 14:30</span> </span>
                    </label>
                  </div>
                  <p className='text-[#697DA4] font-16-600'>Nº Apólice: 1200405</p>
                </div>

              </div>
            ) : (<></>)
          }

        </div>
        <div className='flex flex-col gap-[16px] p-[16px] shadow-lg'>
          {
            !upload ? (
              <button className='h-[3.3rem] w-full rounded-[5px] bg-[#FEF3D1] flex flex-row gap-[8px] justify-center' onClick={() => setUpload(true)}> <img src={financeAssets.ic_arrach} className="self-center" alt='' /><span className='font-14-500 font-color self-center'>Anexar fatura</span></button>
            ) : (
              <button className='h-[3.3rem] w-full rounded-[5px] bg-[#F2F5F8] flex flex-row gap-[8px] justify-between p-[8px]' onClick={() => setUpload(false)}> <span className='font-14-500 text-[#697DA4] self-center'>Fatura 123</span> <CloseIcon /> </button>
            )
          }
          <div className='flex flex-row justify-between'>
            <p className='font-16-500 font-color'>
              {expend && expend1 ? '2' : '1'} pedidos de reembolso
            </p>
            <div className='font-14-400 text-[#95AFC9] flex flex-row gap-[16px]'><span className='self-center'>Total a receber</span>  <span className='font-29-900 font-color'>{total}€</span></div>
          </div>
        </div>
        {expend1 && upload ? (
          <button className='w-full h-[5rem] bg-[#F9BC04] hover:bg-[#29215B]' onClick={onConfirm}>
            <span className='text-white font-15-900 self-center'>SUBMETER PEDIDO</span>
          </button>
        ) : (
          <button className='w-full h-[5rem] bg-[#F2F5F8] '>
            <span className='text-[#B2C3D4] font-15-900 self-center'>SUBMETER PEDIDO</span>
          </button>
        )}
      </ModalBody>
    </Modal>
  );
}

export default DetailModal;